import React, { useState, useEffect } from 'react';
import './App.css';
import './index.css';
import GeneralInformation from './pages/GeneralInformation/GeneralInformation';
import Homepage from './pages/Homepage/Homepage';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import './i18n'; // Importa o arquivo de configuração do i18n
import FarmType from './pages/FarmType/FarmType';
import VegetalProduction from './pages/VegetalProduction/VegetalProduction';
import AnimalProduction from './pages/AnimalProduction/AnimalProduction';
import FuelSpent from './pages/FuelSpent/FuelSpent';
import CarbonFootprint from './pages/CarbonFootprint/CarbonFootprint';
import AskCallForm from './pages/AskCallForm/AskCallForm';
import KnowMore from './pages/KnowMore/KnowMore';
import CarbonImprovement from './pages/CarbonImprovement/CarbonImprovement';
import { AnimatePresence } from "framer-motion";

function App() {
  const [reset, setReset] = useState(false);
  // Estado para armazenar os dados do formulário GeneralInformation
  const [userInfo, setUserInfo] = useState({
    name: '',
    email: '',
    contact: '',
  });

  const [generalInfo, setGeneralInfo] = useState({
    farmName: '',
    farmLocation: '',
    farmSize: '',
  });

  // Estado para armazenar os dados do formulário AnimalProduction
  const [animalProduction, setAnimalProduction] = useState({
    cattle: 0,
    cattle_milk: 0,
    sheep: 0,
    birds: 0,
    rabbits: 0,
    horses: 0,
  });

  const [farmType, setFarmType] = useState({
    producaoAnimal: false,
    producaoAgricola: false,
    producaoFlorestal: false,
    detalhesProducaoFlorestal: {
      montado: false,
      montado_amount: 0,
      eucaliptal: false,
      eucaliptal_amount: 0,
      pinhal: false,
      pinhal_amount: 0,
      outros: false,
    },
    mobilizacaoAgricola: false,
    mobilizacaoMontado: false,
  });

  // Estado para armazenar os dados do formulário AnimalProduction
  const [vegetalProduction, setVegetalProduction] = useState({
    species: {
      cereal: false,
      natural_pasture: false,
      irrigated_pasture: false,
      corn: false,
      rice: false,
      others_cultures: false,
      vineyard: false,
      olive: false,
      almond: false,
      others_orchards: false,
      vegetables: false,
    },
    amount: {
      cereal_amount: 0,
      natural_pasture_amount: 0,
      irrigated_pasture_amount: 0,
      corn_amount: 0,
      rice_amount: 0,
      others_cultures_amount: 0,
      vineyard_amount: 0,
      olive_amount: 0,
      almond_amount: 0,
      others_orchards_amount: 0,
      vegetables_amount: 0,
    }
  });

  // Estado para armazenar os dados do formulário FuelSpent
  const [fuelSpent, setFuelSpent] = useState({
    diesel: '',
    gasoline: '',
  });

  // Estado para armazenar os dados do formulário Footprint
  const [carbonFootprint, setCarbonFootprint] = useState({
    especies: {
      bovinos: false,
      suinos: false,
      ovinos: false,
      aves: false,
      coelhos: false,
      outros: false,
    },
    metodoCriacao: '',
    quantidadeAnimais: '',
    producaoAnual: ''
  });

  useEffect(() => {
    if (reset) {
      setGeneralInfo({
        farmName: '',
        farmLocation: '',
        farmSize: '',
      });
      setAnimalProduction({
        cattle: 0,
        sheep: 0,
        birds: 0,
        rabbits: 0,
        horses: 0,
      });
      setFarmType({
        producaoAnimal: false,
        producaoAgricola: false,
        producaoFlorestal: false,
        detalhesProducaoFlorestal: {
          montado: false,
          eucaliptal: false,
          pinhal: false,
          outros: false,
        },
        mobilizacaoAgricola: false,
        mobilizacaoMontado: false,
      });
      setVegetalProduction({
        species: {
          cereal: false,
          natural_pasture: false,
          irrigated_pasture: false,
          corn: false,
          rice: false,
          others_cultures: false,
          vineyard: false,
          olive: false,
          almond: false,
          others_orchards: false,
          vegetables: false,
        },
        amount: {
          cereal_amount: 0,
          natural_pasture_amount: 0,
          irrigated_pasture_amount: 0,
          corn_amount: 0,
          rice_amount: 0,
          others_cultures_amount: 0,
          vineyard_amount: 0,
          olive_amount: 0,
          almond_amount: 0,
          others_orchards_amount: 0,
          vegetables_amount: 0,
        }
      });
      setFuelSpent({
        diesel: 0,
        gasoline: 0,
      });
      setCarbonFootprint({
        especies: {
          bovinos: false,
          suinos: false,
          ovinos: false,
          aves: false,
          coelhos: false,
          outros: false,
        },
        metodoCriacao: '',
        quantidadeAnimais: '',
        producaoAnual: ''
      });
    }

    setReset(false);
  }, [reset]);

  return (
    <>
      <AnimatePresence mode="wait">
        <Router>
          {/* <Breadcrumb items={breadcrumbItems} /> */}
          <Routes>
            {/* Rota para a página inicial */}
            <Route path="/" element={<Homepage />} />
            {/* Rota para a página de cálculo de pegada de carbono */}
            <Route
              path="/general-information"
              element={
                <GeneralInformation
                  setReset={setReset}
                  generalInfo={generalInfo}
                  setGeneralInfo={setGeneralInfo}
                />
              }
            />
            <Route
              path="/farm-type"
              element={
                <FarmType
                  farmType={farmType}
                  setFarmType={setFarmType}
                />
              }
            />
            <Route
              path="/vegetal-production"
              element={
                <VegetalProduction
                  farmType={farmType}
                  vegetalProduction={vegetalProduction}
                  setVegetalProduction={setVegetalProduction}
                />
              }
            />
            <Route
              path="/animal-production"
              element={
                <AnimalProduction
                  farmType={farmType}
                  animalProduction={animalProduction}
                  setAnimalProduction={setAnimalProduction}
                />
              }
            />
            <Route
              path="/fuel-spent"
              element={
                <FuelSpent
                  fuelSpent={fuelSpent}
                  setFuelSpent={setFuelSpent}
                  setUserInfo={setUserInfo}
                />
              }
            />
            <Route
              path="/carbon-footprint"
              element={
                <CarbonFootprint
                  generalInfo={generalInfo}
                  farmType={farmType}
                  animalProduction={animalProduction}
                  fuelSpent={fuelSpent}
                  vegetalProduction={vegetalProduction}
                  setReset={setReset}
                  setUserInfo={setUserInfo}
                  userInfo={userInfo}
                />
              }
            />
            <Route
              path="/ask-call-form"
              element={
                <AskCallForm
                  animalProduction={carbonFootprint}
                  setAnimalProduction={setCarbonFootprint}
                />
              }
            />
            <Route
              path="/know-more"
              element={
                <KnowMore
                  animalProduction={carbonFootprint}
                  setAnimalProduction={setCarbonFootprint}
                />
              }
            />
            <Route
              path="/carbon-improvement"
              element={
                <CarbonImprovement
                  animalProduction={carbonFootprint}
                  setAnimalProduction={setCarbonFootprint}
                />
              }
            />
          </Routes>
        </Router>
      </AnimatePresence>
    </>
  );
}

export default App;
